// libraries
(function ($) {
  // After swapping buttons to links for SEO, prevent click through to page
  $("#collection-filter-drawer .Linklist__Item a").on("click", function (e) {
    e.preventDefault();
  });

  // On product pages, try use pattern collections to auto select variants
  // Eg. /collections/xxxxx/products/bestie-backpack/
  if ($("body").hasClass("template-product")) {
    // get pattern
    const paths = window.location.pathname.split("/");
    let prev = false;
    let pattern = false;
    $.each(paths, function (i, path) {
      if (prev === "collections") {
        pattern = path.toLowerCase().split("-");
      }
      prev = path;
    });
    // check pattern exists in swatches
    const $swatches = $(".ColorSwatchList label");
    $swatches.each(function () {
      const $swatch = $(this);
      const title = $swatch.data("tooltip").toLowerCase().split(" ");
      let wordsMatch = true;
      $.each(pattern, function (i, word) {
        if ($.inArray(word, title) === -1) {
          wordsMatch = false;
          return false;
        }
      });
      if (wordsMatch) {
        $swatch.trigger("click");
        return false;
      }
    });
  }

  // Product cart limits
  const cartLimit = parseInt(window.theme.cartLimit) || 0;
  if (cartLimit > 0) {
    const $quantityInputs = $(
      '[data-action="increase-quantity"], [name="quantity"]'
    );
    const $decreaseInput = $('[data-action="decrease-quantity"]');
    const $quantity = $('[name="quantity"]');
    const $addToCart = $(".ProductForm__InlineItems");
    let maxTimeout = null;
    $quantityInputs.on("click change", function (e) {
      const quantity = parseInt($quantity.val()) || 0;
      if (quantity >= cartLimit) {
        $quantity.val(cartLimit);
        e.stopPropagation();
        e.preventDefault();
        let $error = $(".ProductForm__Error--cart-limit");
        if ($error.length <= 0 && $addToCart.length > 0) {
          $error = $(
            '<span class="ProductForm__Error Alert Alert--error ProductForm__Error--cart-limit">There is a maximum of ' +
              cartLimit +
              " items per order</span>"
          );
          $addToCart.after($error);
          clearTimeout(maxTimeout);
          maxTimeout = setTimeout(function () {
            $error.remove();
          }, 2500);
        }
      }
    });
    $decreaseInput.on("click change", function (e) {
      const quantity = parseInt($quantity.val()) || 0;
      if (quantity <= cartLimit) {
        const $error = $(".ProductForm__Error--cart-limit");
        if ($error.length > 0) {
          $error.remove();
          clearTimeout(maxTimeout);
        }
      }
    });
  }

  // Holding page height
  $(window).resize(function () {
    $("body")
      .get(0)
      .style.setProperty("--app-height", `${window.innerHeight}px`);
  });
  $("body").get(0).style.setProperty("--app-height", `${window.innerHeight}px`);
})(jQuery);
